import { useMemo } from "react";
import { FEATURE_CONFIG } from "@services/featureConfig/constants";
import {
  useFeatureConfigQuery,
  useLocalFeatureConfigQuery,
} from "@services/featureConfig/queries";
import type { TFeatureConfigEntry } from "@services/featureConfig/types";
import { FeatureConfigContext } from "./FeatureConfigContext";

interface IFeatureConfigProviderProps {
  children?: React.ReactNode;
}

export const FeatureConfigProvider: React.FC<IFeatureConfigProviderProps> = ({
  children,
}) => {
  const { data: localFeatureConfig } = useLocalFeatureConfigQuery();
  const { data: featureConfig } = useFeatureConfigQuery();

  const combinedFeatureConfig = useMemo(() => {
    const normalizedFeatureConfig =
      featureConfig?.featureFlags.reduce<TFeatureConfigEntry>((acc, cur) => {
        acc[cur.featureFlagType] = cur.value;
        return acc;
      }, {} as TFeatureConfigEntry);

    if (!normalizedFeatureConfig) {
      return localFeatureConfig ?? FEATURE_CONFIG;
    }

    const combinedFeatureConfig = {
      ...(localFeatureConfig ?? FEATURE_CONFIG),
      ...normalizedFeatureConfig,
    };

    return combinedFeatureConfig;
  }, [localFeatureConfig, featureConfig]);

  return (
    <FeatureConfigContext.Provider
      value={combinedFeatureConfig ?? FEATURE_CONFIG}
    >
      {children}
    </FeatureConfigContext.Provider>
  );
};
